/* eslint-disable react-hooks/exhaustive-deps */
import { Hub } from 'aws-amplify';
import { History } from 'history';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useComponentDidMount, useComponentWillUnmount } from 'src/hooks';
import { exchangeTokenAsync, getAuthorizedUserAsync, setAuthorizedUser } from 'src/redux/auth/actions';
import { IRootState } from 'src/redux/rootReducer';
import { TokenService } from 'src/services';

const AuthContainer: React.FC<Props> = ({ onSetAuth, onExchangeToken, onGetAuthorizedUser }) => {
  // =========================== Didmount ===========================
  useComponentDidMount(() => {
    if (TokenService.hasToken()) {
      handleGetAuthorizedUser();
    } else {
      clearAuth();
    }
  });

  useComponentDidMount(() => {
    Hub.listen('auth', authLogin);
  });

  useComponentWillUnmount(() => {
    Hub.remove('auth', authLogin);
  });

  const authLogin = (res: { payload: { event: string; data?: any } }) => {
    const { payload } = res;
    const { event } = payload;
    switch (event) {
      case 'signIn':
        handleExchangeToken();
        break;
      case 'signOut':
        TokenService.clearToken();
        clearAuth();
        break;
      case 'signIn_failure':
        console.log('signin error', payload?.data?.message);
        break;
      default:
        break;
    }
  };

  const clearAuth = () => {
    onSetAuth({ isAuthenticated: false, authUser: null });
  };

  const handleExchangeToken = () => {
    onExchangeToken();
  };

  const handleGetAuthorizedUser = () => {
    onGetAuthorizedUser();
  };

  return null;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps & { history: History };

const mapStateToProps = (state: IRootState) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

const mapDispatchToProps = {
  onSetAuth: setAuthorizedUser,
  onExchangeToken: exchangeTokenAsync.request,
  onGetAuthorizedUser: getAuthorizedUserAsync.request,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthContainer));
